import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

const MODAL_STYLE = {
	base: 'modal-cms',
	afterOpen: 'modal-cms-after-open',
	beforeClose: 'modal-cms-before-close'
};

const OVERLAY_STYLE = {
	base: '',
	afterOpen: '',
	beforeClose: ''
};

export default class HFMModalNeo
extends React.Component {
	render () {
		const {
			props,
			props: {
				children,
				styles = {},
				overlayClassName = {}
			}
		} = this;

		return(
			<ReactModal
				shouldCloseOnOverlayClick={ true }
				appElement={ window.document.querySelector('#app') }
				className={ Object.assign({}, MODAL_STYLE, styles) }
				overlayClassName={ Object.assign({}, OVERLAY_STYLE, overlayClassName) }
				{ ...props }
			>
				{ children }
			</ReactModal>
		);
	}
}
